/**
 * @generated SignedSource<<800bc9870e5034da128ae68813a6b937>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WebSettingsCreateJoinTeamRelayQuery$variables = {
  orgRelayId: string;
};
export type WebSettingsCreateJoinTeamRelayQuery$data = {
  readonly viewer: {
    readonly __typename: string;
    readonly teamQueryResultErrorable: {
      readonly __typename: "TeamQueryResult";
      readonly query: string;
      readonly teams: ReadonlyArray<{
        readonly teamId: string;
      }>;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
  readonly org: {
    readonly id?: string;
    readonly userTeams?: {
      readonly __typename: "TeamList";
      readonly list: ReadonlyArray<{
        readonly teamId: string;
        readonly teamName: string;
      }>;
    } | {
      readonly __typename: "GraphEntityError";
      readonly statusCode: number | null;
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
    readonly " $fragmentSpreads": FragmentRefs<"TeamJoinCreateDialogRenderer_org">;
  } | null;
};
export type WebSettingsCreateJoinTeamRelayQuery = {
  variables: WebSettingsCreateJoinTeamRelayQuery$variables;
  response: WebSettingsCreateJoinTeamRelayQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgRelayId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "excludeMyTeams",
    "value": false
  },
  {
    "kind": "Variable",
    "name": "orgRelayId",
    "variableName": "orgRelayId"
  },
  {
    "kind": "Literal",
    "name": "query",
    "value": ""
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "query",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamId",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "orgRelayId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamName",
  "storageKey": null
},
v8 = [
  (v4/*: any*/),
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusCode",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/)
  ],
  "type": "GraphEntityError",
  "abstractKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personId",
  "storageKey": null
},
v13 = [
  (v6/*: any*/)
],
v14 = {
  "kind": "InlineFragment",
  "selections": (v13/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryCalendarId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v9/*: any*/)
  ],
  "type": "GraphEntityError",
  "abstractKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "Urn",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isYou",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "UserProfile",
  "kind": "LinkedField",
  "name": "profile",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "givenName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "familyName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalImageUrl",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OrgPerson",
    "kind": "LinkedField",
    "name": "person",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v6/*: any*/),
      (v15/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v12/*: any*/),
      (v22/*: any*/)
    ],
    "storageKey": null
  }
],
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamMember",
  "kind": "LinkedField",
  "name": "teamMembers",
  "plural": true,
  "selections": (v23/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WebSettingsCreateJoinTeamRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "teamQueryResultErrorable",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v1/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "teams",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "TeamQueryResult",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "org",
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamJoinCreateDialogRenderer_org"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "userTeams",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "TeamList",
                    "abstractKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Org",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WebSettingsCreateJoinTeamRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "teamQueryResultErrorable",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "teams",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "type": "TeamQueryResult",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "org",
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryOrgEmail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000000
                  }
                ],
                "concreteType": "WorkingGroupConnection",
                "kind": "LinkedField",
                "name": "workingGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WorkingGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WorkingGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "calendarIds",
                            "storageKey": null
                          },
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "workingGroups(first:1000000)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "primaryOrgCalendar",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "orgPersonForUserErrorable",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v12/*: any*/)
                    ],
                    "type": "OrgPerson",
                    "abstractKey": null
                  },
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "primaryTeam",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "Team",
                    "abstractKey": null
                  },
                  (v11/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "featureGrid",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PaymentStateMetadata",
                        "kind": "LinkedField",
                        "name": "stateMetadata",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PrimaryBillingGroupMetadata",
                            "kind": "LinkedField",
                            "name": "primaryBillingGroupMetadata",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PaymentSubscription",
                                "kind": "LinkedField",
                                "name": "subscription",
                                "plural": false,
                                "selections": (v13/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserMetadata",
                            "kind": "LinkedField",
                            "name": "userMetadata",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrgPerson",
                                "kind": "LinkedField",
                                "name": "person",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TrialMetadata",
                                "kind": "LinkedField",
                                "name": "trialMetadata",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "trialEndDate",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "timeZone",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isTrialExpired",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "FeatureGrid",
                    "abstractKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "billingGroups",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BillingGroup",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Urn",
                            "kind": "LinkedField",
                            "name": "syncSources",
                            "plural": true,
                            "selections": [
                              (v16/*: any*/),
                              (v17/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PaymentSubscription",
                                    "kind": "LinkedField",
                                    "name": "subscription",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "productType",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "SubscriptionDetails",
                                "abstractKey": null
                              },
                              (v18/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "BillingGroupList",
                    "abstractKey": null
                  },
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "userTeams",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          (v4/*: any*/),
                          (v7/*: any*/),
                          (v19/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "teamCalendarId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "manageTeamCalendar",
                                    "storageKey": null
                                  }
                                ],
                                "type": "TeamSettings",
                                "abstractKey": null
                              },
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "userSettings",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "useTeamCalendar",
                                    "storageKey": null
                                  }
                                ],
                                "type": "TeamUserSettings",
                                "abstractKey": null
                              },
                              (v14/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v24/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "invitedMembers",
                            "plural": true,
                            "selections": (v23/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "TeamList",
                    "abstractKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "suggestedTeams",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SuggestedTeam",
                        "kind": "LinkedField",
                        "name": "list",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Team",
                            "kind": "LinkedField",
                            "name": "team",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v4/*: any*/),
                              (v7/*: any*/),
                              (v19/*: any*/),
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TeamMember",
                                "kind": "LinkedField",
                                "name": "invitedMembers",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrgPerson",
                                    "kind": "LinkedField",
                                    "name": "person",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      (v6/*: any*/),
                                      (v15/*: any*/),
                                      (v20/*: any*/),
                                      (v21/*: any*/),
                                      (v22/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SuggestedTeamReason",
                            "kind": "LinkedField",
                            "name": "reasons",
                            "plural": true,
                            "selections": [
                              (v16/*: any*/),
                              (v17/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "score",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "SuggestedTeamList",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Org",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "13945e110bcf7d114597611853ee2fea",
    "id": null,
    "metadata": {},
    "name": "WebSettingsCreateJoinTeamRelayQuery",
    "operationKind": "query",
    "text": "query WebSettingsCreateJoinTeamRelayQuery(\n  $orgRelayId: ID!\n) {\n  viewer {\n    __typename\n    teamQueryResultErrorable(query: \"\", orgRelayId: $orgRelayId, excludeMyTeams: false) {\n      __typename\n      ... on TeamQueryResult {\n        __typename\n        query\n        teams {\n          teamId\n          id\n        }\n      }\n    }\n    id\n  }\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      id\n      ...TeamJoinCreateDialogRenderer_org\n      userTeams {\n        __typename\n        ... on TeamList {\n          list {\n            teamId\n            teamName\n            id\n          }\n        }\n        ... on GraphEntityError {\n          statusCode\n          message\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment TeamJoinCreateDialogRenderer_org on Org {\n  ...TeamJoinCreate_org\n  id\n  primaryOrgCalendar\n}\n\nfragment TeamJoinCreate_org on Org {\n  id\n  primaryOrgEmail\n  workingGroups(first: 1000000) {\n    edges {\n      node {\n        calendarIds\n        id\n      }\n    }\n  }\n  primaryOrgCalendar\n  orgPersonForUserErrorable {\n    __typename\n    ... on OrgPerson {\n      personId\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  primaryTeam {\n    __typename\n    ... on Team {\n      teamId\n      teamName\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  featureGrid {\n    __typename\n    ... on FeatureGrid {\n      stateMetadata {\n        primaryBillingGroupMetadata {\n          subscription {\n            id\n          }\n        }\n        userMetadata {\n          person {\n            primaryCalendarId\n            id\n          }\n          trialMetadata {\n            trialEndDate\n            timeZone\n            isTrialExpired\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n  billingGroups {\n    __typename\n    ... on BillingGroupList {\n      list {\n        id\n        name\n        syncSources {\n          type\n          value\n          id\n        }\n        subscription {\n          __typename\n          ... on SubscriptionDetails {\n            subscription {\n              id\n              productType\n            }\n          }\n          ... on GraphEntityError {\n            message\n            statusCode\n          }\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n  }\n  userTeams {\n    __typename\n    ... on TeamList {\n      list {\n        id\n        teamId\n        teamName\n        createdBy {\n          value\n          id\n        }\n        teamCalendarId\n        settings {\n          __typename\n          ... on TeamSettings {\n            manageTeamCalendar\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        userSettings {\n          __typename\n          ... on TeamUserSettings {\n            useTeamCalendar\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        teamMembers {\n          person {\n            __typename\n            id\n            primaryCalendarId\n            isYou\n            userId\n            personId\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n          }\n        }\n        invitedMembers {\n          person {\n            __typename\n            id\n            primaryCalendarId\n            isYou\n            userId\n            personId\n            profile {\n              givenName\n              familyName\n              externalImageUrl\n            }\n          }\n        }\n      }\n    }\n  }\n  suggestedTeams {\n    __typename\n    ... on SuggestedTeamList {\n      list {\n        team {\n          id\n          teamId\n          teamName\n          createdBy {\n            value\n            id\n          }\n          teamMembers {\n            person {\n              __typename\n              id\n              primaryCalendarId\n              isYou\n              userId\n              personId\n              profile {\n                givenName\n                familyName\n                externalImageUrl\n              }\n            }\n          }\n          invitedMembers {\n            person {\n              __typename\n              id\n              primaryCalendarId\n              isYou\n              userId\n              profile {\n                givenName\n                familyName\n                externalImageUrl\n              }\n            }\n          }\n        }\n        reasons {\n          type\n          value\n        }\n        score\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b4586f073ededb3648ac55e41cfa747f";

export default node;
